import { gql } from "@apollo/client"; import { useLazyQuery, useMutation } from "@apollo/client/react";
import EditIcon from '@mui/icons-material/Edit';
import React, { useEffect, useMemo, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { Outlet, useNavigate } from 'react-router-dom';
import ErrorDialog from '../../../components/ErrorDialog';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { SwitchInput } from '../../../components/switchInput/SwitchInput';

export default function RoleAll({ setChildrenAction }) {

  const [datos, setDatos] = useState([]);
  const navigate = useNavigate();


  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setChildrenAction(() =>
      <div>
        <CustomButton
          onClick={handleNew}>
          Nuevo
        </CustomButton>
      </div>
    );
  }, [setChildrenAction]);

  const initialColumns = [
    {
      field: 'action',
      headerName: '',
      flex: 0.05,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <PopoverModal>
            <div className='popover-modal-content'>
              <div onClick={() => handleEdit(row)} aria-hidden='true' className='item-option clickable-option'>
                <EditIcon className='edit-icon' />
                <span className='toggle-action'>Editar</span>
              </div>
              <div className='item-option'>
                <span className='toggle-action'>Activo</span>
                <SwitchInput
                  onChange={(e) => {
                    handleDelete(row);
                  }}
                  checked={row?.activo} />

              </div>
            </div>
          </PopoverModal>);

      }
    },
    { field: 'id', headerName: 'ID', flex: 0.13 },
    { field: 'descripcion', headerName: 'Descripción', flex: 0.6 },
    { field: 'funcion', headerName: 'Función' },
    { field: 'descripcionProfesional', headerName: 'Tipo de profesional' },
    { field: 'activo', type: 'boolean', headerName: 'Activo' }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  useEffect(() => {
    getRoles();
  }, []);

  const QGetRoles = gql`
        query QGetRoles{
            roles {
                success,
                error,
                valorEsperado {
                  id,
                  descripcion,
                  idFuncion,
                  idTipoProfesional,
                  activo,
                  descripcionProfesional,
                  funcion
                }
              }
        }`;

  const [getRoles, { error, data: dataRoles }] = useLazyQuery(QGetRoles, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if(!dataRoles?.roles?.success) return;
    
    setDatos(dataRoles.roles.valorEsperado);
  }, [dataRoles]);


  const MDeleteRol = gql`
    mutation MDeleteRol( $idRol: Int!){
        deleteRol(idRol: $idRol) 
        {
            success,
            error,
            valorEsperado
        }
    }`;
  const [deleteRol, { dataMDeleteRol }] = useMutation(MDeleteRol, {
    onCompleted: (dataMDeleteRol) => {
      if (dataMDeleteRol.deleteRol.success) {
        toast.success("Se eliminó el rol de forma correcta");
        getRoles();
      } else {
        if (dataMDeleteRol.deleteRol.error === 'ERRORDB' || parseInt(dataMDeleteRol.deleteRol.error, 10) > 0) {
          setMensajeError(dataMDeleteRol.deleteRol.error);
        } else {
          toast.error(dataMDeleteRol.deleteRol.error);
        }
      }
    },
    onError: (dataMDeleteRol) => {
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const handleEdit = (row) => {
    navigate('/role/' + row.id, { state: { role: row, edit: true } });
  };

  const handleNew = () => {
    navigate('/role/0', {
      state: {
        role: {
          id: 0,
          descripcion: '',
          idFuncion: 0,
          idTipoProfesional: 0,
          activo: true
        }, edit: false
      }
    });
  };

  const handleDelete = (row) => {
    let id = row.id;
    EliminarRol(id);
  };

  const EliminarRol = (id) => {
    deleteRol({ variables: { idRol: id } });
  };

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  return (
    <>
      <DataGridGenerico
        columns={columns}
        fileNameExport='Roles'
        rows={datos}
        toolbar={false}
        totalCount={datos.length} />

      <Outlet />

      <ErrorDialog
        id="dlg-error-chgpass"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />

    </>);


}